import { Component, OnInit } from '@angular/core';
import { RPCDexPriceDiscrepenciesFilter, RPCDexPriceDiscrepenciesFilterItemsResponse } from '../../../remote-price-change/remote-price-change-service/remote-price-change.model';
import { FilterBarService } from '../../filter-bar-service/filter-bar.service';
import { ISubscription } from 'rxjs-compat/Subscription';

@Component({
  selector: 'app-rpc-dex-price-filters',
  templateUrl: './rpc-dex-price-filters.component.html',
  styleUrls: ['./rpc-dex-price-filters.component.scss']
})
export class RpcDexPriceDiscrepenciesFiltersComponent implements OnInit {
  vendorCodesDropdown: string[];
  machineSearch: string;
  machineSearchError: string;
  filterItem:RPCDexPriceDiscrepenciesFilter;
  
  constructor(private _filter: FilterBarService) { }

  ngOnInit() {
    this.vendorCodesDropdown = new Array();
    this.filterItem = new RPCDexPriceDiscrepenciesFilter();

    this._filter.GetRPCDexPriceDiscrepencyFilterData().subscribe((data: RPCDexPriceDiscrepenciesFilterItemsResponse) => {
      this.fillDropdowns(data);
    });

    this._filter.resetFilters.subscribe(data => {
      this.performReset();
    });
  }

  private fillDropdowns(data: RPCDexPriceDiscrepenciesFilterItemsResponse) {
    data.vendors.forEach(y => {
      this.vendorCodesDropdown.push(y.vendorCode);
    });
  }

  changeVendorCode(selection) {
    this.filterItem.vendorCode = selection === "" ? null : selection;
    this._filter.updateRpcDexPriceFilter(this.filterItem);
  }

  updateMachineNumberFilter(newSearch: string) {
    const machineNumber = Number(newSearch);
    if (newSearch.length > 0 && isNaN(machineNumber)) {
      this.machineSearchError = 'Search must be a number';
    }
    else 
    {
      this.filterItem.machineNumber = machineNumber; 
      this._filter.updateRpcDexPriceFilter(this.filterItem);
      this.machineSearchError = '';
    }
  }

  showMachineNumberError() {
    return this.machineSearchError;
  }

  showVendorCodeError() {
  }

  performReset() {
    const vcdropdown = document.getElementById("vendorCodeDropdown") as HTMLSelectElement;
    vcdropdown.selectedIndex = 0;
    this.filterItem.vendorCode = null;
    this.machineSearch = null;
    this.machineSearchError = null;
    this.filterItem.machineNumber = null;
    this._filter.updateRpcDexPriceFilter(this.filterItem);
  }
}
